import { pickupCarousel, articleCarousel } from "./modules/carousel"
import { anchorScroll } from "./modules/anchor"
import { scrollTable } from "./modules/tablescroll"
import { accordion } from "./modules/accordion"
import { asideNav } from "./modules/aside_nav"
import { tabs } from "./modules/tabs"

const pagetoTop = () => {
  let pageTop = $('#back-top');
  pageTop.on('click', function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });
}
const headerfixed = () => {
  var headerHeight = $('.header').outerHeight();
  $('body > main').css('padding-top', headerHeight);
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 1) {
      $('header').addClass("--sticky");
    }
    else {
      $('header').removeClass("--sticky");
    }
  });
}
const initMobileMenu = () => {
  $('.menu-btn').on('click', function () {
    $('html').toggleClass('mn-open');
    $('.overlay-header').on('click', function () {
      $('html').removeClass('mn-open');
    });
  });
}
const navDropdown = () => {
  let itemDrop = $(".nav__item.dropdown > .nav--link");
  itemDrop.on('click', function () {
    itemDrop.not($(this)).removeClass('is-open');
    itemDrop.not($(this)).next('.dropdown-menu').slideUp(200);

    $(this).toggleClass('is-open');
    $(this).next('.dropdown-menu').slideToggle(300);
  });
  let navclose = itemDrop.parents().find('.close');
  navclose.on('click', function () {
    $(this).parents(".dropdown").find('.nav--link').toggleClass("is-open");
    $(this).parents(".dropdown-menu").slideToggle(200);
  });
}



$(function () {
  headerfixed();
  initMobileMenu();
  navDropdown();
  pagetoTop();
  pickupCarousel();
  articleCarousel();



  anchorScroll();
  scrollTable();
  accordion();
  asideNav();
  tabs();
});

var iv = null;
$(window).on('resize', () => {
  if (iv !== null) {
    window.clearTimeout(iv);
  }
  iv = setTimeout(function () {
    scrollTable();
    headerfixed();
  }, 50);
});
